import React, { useState, useEffect } from 'react'
import "../assets/styles.css";
import menu from "../assets/img/menu.png"
import header from "../assets/img/header.png"
import close from "../assets/img/Close.png"
import { Link } from 'react-router-dom';

function NavBar() {
    const [isNavExpanded, setIsNavExpanded] = useState(false)
    return (
        <header className="header">
            <div className="brand">
                <Link to="/" className="brand-logo">
                    <img src={header} alt="Menu" onClick={() => {
                        setIsNavExpanded(true);
                    }} style={{ height: '90px' }} />
                </Link>
                <div className="nav-burger" id="nav-burger">
                    <img src={menu} alt="Menu" onClick={() => {
                        setIsNavExpanded(true);
                    }} />
                </div>
            </div>
            <nav className={isNavExpanded ? "nav-custom open-menu" : "nav-custom is-active"} >
                <div className={isNavExpanded ? "nav-cancel" : "nav-cancel is-active"}>
                    <img src={close} onClick={() => {
                        setIsNavExpanded(false);
                    }} alt="Cancel" />
                </div>
                <div className='nav-links_div'>
                    <Link to="https://www.r0arsociety.io/" target='_blank' className="nav-link_ref">Home</Link>
                    <Link to="https://guild.xyz/r0ar-society" target='_blank' className="nav-link_ref">Penthouse Suite</Link>
                    <Link to="https://www.r0arsociety.com/" target='_blank' className="nav-link_ref">Merch</Link>
                    <Link to="/staking" className="nav-link_ref">Staking</Link>
                    <Link to="/explorer" className="nav-link_ref">Explorer</Link>

                    <w3m-button />
                </div>
            </nav>
        </header>
    );
}

export default NavBar